import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import TopNav from './TopNav';
import FixedSideNav from './FixedSideNav';
import MobileBottomNav from './MobileBottomNav';

const MainLayout = ({ children }) => {
  const [sidebarWidth, setSidebarWidth] = useState(256);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleSidebarWidthChange = (width) => {
    setSidebarWidth(width);
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {/* Fixed Side Navigation (desktop only) */}
      <FixedSideNav onWidthChange={handleSidebarWidthChange} />

      {/* Main Content Area */}
      <Box
        sx={{
          flexGrow: 1,
          ml: isMobile ? 0 : `${sidebarWidth}px`,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          transition: 'margin-left 0.3s ease',
        }}
      >
        {/* Main Content */}
        <Box
          component="main"
          sx={{
            flex: 1,
            position: 'relative',
            backgroundColor: (theme) => theme.palette.background.default,
            overflow: 'auto',
            minHeight: '100vh',
            pb: isMobile ? '60px' : 0,
          }}
        >
          {children}
        </Box>
      </Box>

      {/* Mobile Bottom Navigation */}
      <MobileBottomNav />
    </Box>
  );
};

export default MainLayout;
